module.exports = __webpack_public_path__ + "img/logo-saml@2x.7bb24f5f.png";